module.exports = __webpack_public_path__ + "static/media/main_background.924a2cf6.mp3";